import { useSearchParams } from 'react-router-dom';
import MenuComponent from './menu/MenuComponent';


function App() {
    const [searchParams] = useSearchParams();

    let interactiveActivityId = searchParams.get('iaid');

    return (<>
        <MenuComponent />
    </>);
}

export default App;
